import { combineReducers } from 'redux';

import homeReducer from '../Reducers/HomeReducer';
import loaderReducer from './LoaderReducer';
const rootRuducer = combineReducers({
  home: homeReducer,
  loader: loaderReducer,
});

export default rootRuducer;
